require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./apis-and-microservices-managing-packages-with-npm-use-the-caret-character-to-use-the-latest-minor-version-of-a-dependency.json") })
        }
      }, "path---apis-and-microservices-managing-packages-with-npm-use-the-caret-character-to-use-the-latest-minor-version-of-a-dependency");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---apis-and-microservices-managing-packages-with-npm-use-the-caret-character-to-use-the-latest-minor-version-of-a-dependency!./.cache/json/apis-and-microservices-managing-packages-with-npm-use-the-caret-character-to-use-the-latest-minor-version-of-a-dependency.json
// module id = 1274
// module chunks = 231608221292675